import { render, staticRenderFns } from "./CreateFaq.vue?vue&type=template&id=512349f4&scoped=true"
import script from "./CreateFaq.vue?vue&type=script&lang=js"
export * from "./CreateFaq.vue?vue&type=script&lang=js"
import style0 from "./CreateFaq.vue?vue&type=style&index=0&id=512349f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512349f4",
  null
  
)

export default component.exports